module.exports = __webpack_public_path__ + "img/feedback.74f041a3.svg";